import React, { useState, useRef, useEffect } from "react";
import { Link, Navigate } from "react-router-dom";
import SlideOver from "../components/slideover/slideover";
import Tab from "../components/tab/tab";
import Table from "../components/Table/Table";
import Header from "../templates/Header/Header";
import "./../styles/lattice.css";
import { myLatticeFilter } from "../selectors/dashboard";
import { userDataState } from "../atoms/dashboard";
import { useRecoilState, useRecoilValue, useRecoilRefresher_UNSTABLE, useResetRecoilState } from "recoil";
import addIcon from "../images/svg/add_icon.svg";
import editIcon from "../images/svg/edit_icon.svg";
import delIcon from "../images/svg/delete_icon.svg";
import { clat } from "./uatlattice";
import { getMydivision1, getOtherdivision } from "../selectors/lattice";
import { otherDivData } from "../atoms/lattice";
import { getOthDivData } from "../api/update";
import { Myrole } from "./myrole";
import norecrd from "../images/png/norcrdfnd.png";
import { Loading } from "..";
import { otherDiv } from "../atoms/dashboard";
import { frmPage } from "../atoms/dashboard";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import { MycarUrl } from "../selectors/baseurl";
export const groupBy = keys => array =>
  array?.reduce((objectsByKeyValue, obj) => {
    const value = keys?.map(key => obj[key])?.join('-');
    objectsByKeyValue[value] = (objectsByKeyValue[value] || [])?.concat(obj);
    return objectsByKeyValue;
  }, {});
const PresentationServices = (props) => {
  const usrData = useRecoilValue(userDataState);
  const getodiv = useRecoilValue(getOtherdivision);
  const getotherDiv = useRecoilValue(otherDiv);
  const frmPageVal = useRecoilValue(frmPage);
  if (usrData?.isLogged == false) window.location.href = MycarUrl;//
  console.log("frmPageVal>>",frmPageVal);
  console.log("getotherDiv", getotherDiv);
  const redPg= frmPageVal =='dashboard' ? '':<Link to='/explore-roles'>Compactable Streams/Roles</Link>;
  const [, setotherDiv] = useRecoilState(otherDiv);
  console.log('odiv==data', getodiv);
  const [othrdvdata, setOthrdvdata] = useRecoilState(getMydivision1);
  const resetothdata = useResetRecoilState(otherDivData);
  console.log(usrData);
  
  console.log('division datasss123444444---', othrdvdata);

  const [slideData, setSlideData] = useState([]);
  //const [latData, setLatData] = useState(latticeData);
  const [divVal, setdivVal] = useState([]);
  const [divonchg, setDivOnchg] = useState('');
  const [teamVal, setteamVal] = useState([]);
  const [loading, setloading] = useState(false);
  let resOthDat = '';
  let jobRows = 0;
  const latFilDat = useRecoilValue(myLatticeFilter);
  const getMydivisionData = useRecoilValue(getMydivision1);
  resOthDat = useRecoilValue(getMydivision1);
  const resDivval = useRecoilValue(getMydivision1);
  const [divData, setDivdata] = useState(resOthDat);
  //const getMydivisionData = clat;
  const locRef = useRef(null);
  const divRef = useRef(null);
  const teamRef = useRef(null);
  const streamRef = useRef(null);
  const substreamRef = useRef(null);
  const loadingRef = useRef(null);
  const carlatRef = useRef(null);
  let currentLvel = "";
  let popUplbl = "";
  let oldStream = "";
  let oldBgColor = "";
  // console.log(latFilDat);
  console.log(getMydivisionData);

  const lvlChk = ['L1', 'L2', 'L3', 'L4', 'L5', 'L6', 'L7', 'L8', 'L9'];
  const groupByUpd = (keys) => (array) =>
    array?.reduce((objectsByKeyValue, obj) => {
      // Instead of creating a unique key for each grouped by values, we are now traversing (and building) 
      // the whole object structure for every array value:
      keys?.reduce((builder, key, index) => {
        //console.log('builder>>>',builder);
        if (index !== keys?.length - 1) {
          // Building the nested grouped by structure
          builder[obj[key]] = builder[obj[key]] || {};
          //console.log(key);
        } else {

          // Appending the current object at the leaf node
          builder[obj[key]] = lvlChk.includes(obj[key]) ? (builder[obj[key]] || []).concat(obj) : [""];
        }
        return builder[obj[key]];
      }, objectsByKeyValue);

      return objectsByKeyValue;
    }, {});


  useEffect(() => {
    //console.log('useeffect lat', getotherDiv, usrData.locationGroupID, usrData.divisionID);

    if (getotherDiv == false) {
      locRef.current.value = 1;
      divRef.current.value=usrData.divisionID;
      handleDivChange();
      setDivOnchg(usrData.divisionID);
    }

  }, []);


  function onlyUnique(value, index, self) {
    //console.log(value, index, self);
    return self.indexOf(value) === index;
  }
  function uniqueArr(arrVal, cond) {

    let result = arrVal.reduce((unique, o) => {
      if (!unique.some(obj => obj[cond] === o[cond])) {
        unique.push(o);
      }
      return unique;
    }, []);
    return result;
  }
  function getFileterVals(arr, cond, val) {
    let divDetails = latFilDat[arr].filter((vals) => vals[cond] == val);

    return divDetails;
  }
  const handleDivChange = () => {
    // console.log(locRef.current.value);
    let resDiv = getFileterVals('divisionTeams', 'locationID', locRef.current.value);
    divRef.current.value = '';
    teamRef.current.value = '';
    let uniquarr = uniqueArr(resDiv, 'divisionID');
    
    setdivVal(uniquarr);
   // console.log('disable_temref',uniquarr);
    if (locRef.current.value != '') {
      locRef.current?.parentElement?.classList?.remove("error");
    }
    handleTeamChange();
  }
  const handleTeamChange = () => {
    // console.log(locRef.current.value);
    teamRef.current.value = '';
   
    setDivOnchg('');
   
    setteamVal(getFileterVals('divisionTeams', 'divisionID', divRef.current.value!=""?divRef.current.value:usrData.divisionID).filter((vals)=>vals['functionName'] === "Support"));
  
    if (divRef.current.value != '') {
   
      divRef.current?.parentElement?.classList?.remove("error");
      setDivOnchg(divRef.current.value);
      //divRef.current.getAttribute("title").value="Prasaa"
    }
    //alert("divref vass>>>"+divRef.current.value);
    console.log(getFileterVals);
  }
  const streamChange = () => {
    substreamRef.current.value = '';
    setteamVal(getFileterVals('divisionTeams', 'divisionID', streamRef.current.value));
    console.log(getFileterVals);
  }
  const resetFilter = () => {
    locRef.current.value = usrData.locationGroupID;
    divRef.current.value = usrData.divisionID;
    //teamRef.reset();
    handleDivChange();
    streamRef.current.value = '';
    substreamRef.current.value = '';
    console.log('resOthDat>>',resDivval);
    setDivdata(resDivval);
    setDivOnchg(usrData.divisionID);
    divRef.current.value = usrData.divisionID;
    
  }
  const driverObj = driver({
    showProgress: true,
    steps: [
      { element: '.career_lattice', popover: { title: 'Career Lattice', description: '<p>This feature provides the holistic view of available jobs at RRD, you can explore the opportunities in RRD based on the search parameters.</p>' } }
       ]
  });
  const help_coach = () => {
    driverObj.drive();
  };
  const applyFilter = async () => {

    if (locRef.current.value == '') {
      locRef.current.parentElement.classList.add("error");
      return false;
    } else if (divRef.current.value == '') {
      //alert('Please select division');
      divRef.current.parentElement.classList.add("error");
      return false;
    } else {
      loadingRef.current.classList.toggle("hidden");
      carlatRef.current.classList.add("hidden");
      let ipJsonVal = {
        "loc": locRef.current.value,
        "div": divRef.current.value,
        "team": teamRef.current.value,
        "stream": streamRef.current.value,
        "substream": substreamRef.current.value
      }
      resOthDat = await getOthDivData(ipJsonVal);

      if (resOthDat?.status == 200) {

        resOthDat = resOthDat?.data;
        loadingRef.current.classList.toggle("hidden");
        carlatRef?.current?.classList?.remove("hidden");
        setDivdata(resOthDat);
        setotherDiv(false);
      }

    }

  }

  //const groupByStreamSubLevel = groupBy(['streamName', 'subStreamName', 'jobLevelName']);
  const groupByStreamSubStream = groupBy(['streamName', 'subStreamName']);
  const jobLevelName = groupBy(['jobLevelName']);
 // const resData = getMydivisionData != 'No record found' ? groupByStreamSubLevel(getMydivisionData) : [];
  //const headerGroupData = getMydivisionData != 'No record found' ? groupByStreamSubStream(getMydivisionData) : [];
  //const jobLevelData = getMydivisionData != 'No record found' ? jobLevelName(Object.values(headerGroupData)) : [];
  const groupByStreamSubLevel1 = groupByUpd(['streamName', 'subStreamName', 'jobLevelName']);
  let resData1 = divData != 'No record found' && (getotherDiv == false) ? groupByStreamSubLevel1(divData) : [];
  let headData = divData != 'No record found' && (getotherDiv == false) ? groupByStreamSubStream(divData) : [];
  const arrCnt = Object.keys(headData)?.length;
  console.log(arrCnt);
  let headerGroupData1 = [];

  console.log('resData1', resData1);
  // console.log('0th array',Object.values(resData1));
  //console.log('hedergrpdata', headerGroupData);
  //return false;
  // console.log('jobLevelpras',jobLevelData);
  const lvlArrVal = ['L1', 'L2', 'L3', 'L4', 'L5', 'L6', 'L7', 'L8', 'L9'];
 // const psData = resData;

  window.addEventListener('click', function (e) {
    if (!e.target.classList.contains('plusCount')) {
      document.querySelectorAll('.popup_data').forEach(function (elem) {
        elem.classList?.add('hidden');
      })
    }
  })

  function Lattice(props) {
    //const Lattice = (props) => {
    console.log('inside praslat', props);
    const contentLat = [props?.data];
    const DataLength = props?.data?.length;
    console.log(DataLength)
    function openPop(event) {
      document.querySelectorAll('.popup_data').forEach(function (elem) {
        elem.classList?.add('hidden');
      })
      document
        ?.getElementById(
          event.currentTarget.getAttribute("data-popover-target")
        )
        ?.classList?.toggle("hidden");
    }

    function openSlide(info) {
      console.log(info);
      const title = info.divisionName + ' / ' + info.streamName + ' / ' + info.subStreamName + ' / ' + info.jobLevelName + ' / ' + info.jobTitleName;
      setSlideData(<SlideOver isCareerLatticePage={true} data={<Myrole datas={info} from={"lattice"} />} customCls={"lattice"} head={title} />);
      document?.querySelector(".slideover")?.classList?.remove("hidden");
    }
    console.log(contentLat);
    return (
      <>
        {/* {contentLat.map((level, idx) => (
            <> {level.length+'--'+level[idx]?.jobTitleName +'--'+idx}
              <p onClick={openSlide}>{level[idx].jobTitleName ? level[idx].jobTitleName : "Level not configured"} </p> 
            
              </>
        ))} */}

        {contentLat.map((level, idx) => (

          <>
            {level.length > 0 && level[idx].jobTitleName ? <p>
              {/* <span onClick={() => openSlide(level[idx])}>{level[idx].jobTitleName ? level[idx].jobTitleName : "Level not configured"}</span> */}
              <span onClick={() => openSlide(level[idx])}>{level[idx].jobTitleName ? level[idx].jobTitleName : " "}</span>
              {level.length > 1 ? <><div className="plusCount" data-popover-target={`popover-click${level[idx]?.stream_ID}-${level[idx]?.subStream_ID}-${level[idx]?.jobLevelName}`} onClick={openPop}>,+{level.length > 1 ? "+" + level.length - 1 : ''}
                <div className={`popup_data absolute z-10 hidden w-32 ${arrCnt > 5 && arrCnt - props?.jobrws <= 3 ? 'popup-top' : ''}`} data-popover id={`popover-click${level[idx]?.stream_ID}-${level[idx]?.subStream_ID}-${level[idx]?.jobLevelName}`} role="tooltip" >
                  <h3>{level[0].streamName} {level[0].subStreamName} - {level[0].jobLevelName}</h3>
                  {level.map((level1, idx1) => (
                    idx1 > 0 ?
                      <p onClick={() => openSlide(level1)}>{level1.jobTitleName ? level1.jobTitleName : " "}  </p> : <></>
                  ))}

                </div>
              </div>
              </>

                : <></>}
             {/* </p> : <>Level not configured</> */}
            </p> : <> </>}

          </>
        ))}
       
      </>
    );
  }


  function getRandomColor() {
    // const rgb = string => string.match(/\w\w/g).map(b => parseInt(b, 16))
    // const rgbrnd = (rgb1, rgb2) => {
    //   const rgb3 = [];
    //   for (let i = 0; i < 3; i++) rgb3[i] = rgb1[i] + Math.random() * (rgb2[i] - rgb1[i]) | 0;
    //   return '#' + rgb3
    //     .map(n => n.toString(16).padStart(2, '0'))
    //     .join('');
    // };


    // const rgb1 = rgb("#a4d541"); 
    // const rgb2 = rgb("#367dd3"); 
    // return rgbrnd(rgb1, rgb2);


  }

  const rand = ['#a4d541', '#3acc97', '#2fcccb', '#3c9dd3', '#367dd3', '#5fc796', '#7795cf'];

  return (
    <>
      <div className="mx-auto h-full w-full">
        <div className="main-section">
          <Header onBtnClick={help_coach}/>
          <main>
            <div className="mx-auto h-full w-full">
              <div id="presentServices" className="px-7 py-4">
                <header className="flex">
                  {/* <p>Operations | Creative Communication</p>
                  <h1>{usrData.divisionName}</h1> */}
                   <div className="breadcrumb"><h2 className="ml-0 text-[16px] text-[#033d9b] tracking-[1px] font-extrabold uppercase"> <Link to='/dashboard'>Dashboard</Link> / {redPg} {redPg!=''?'/':''} Career Lattice - {usrData.divisionID == divonchg ? 'My Division' : 'Other Division'}</h2></div>
                  <div className="multiple_position"><span></span><i className="font-semibold text-[11px]">Click (+) to view the multiple positions</i></div>
                </header>
                <main>
                  <div className="search">
                    <div className="relative">
                      <div className="flex flex-wrap filter-outer">
                        <h2>Filter By </h2>
                        <div className="flex-none">
                          <div className="w-full flex flex-col" >
                            <label htmlFor="location" className="text-[12px]">Location <sup>*</sup></label>
                            <select id="location" name="location" className="block w-full" ref={locRef} onChange={handleDivChange}>
                              <option value=''>Select Location</option>
                              {latFilDat?.locationDetails?.map((heading, i) => (
                                <option value={heading.locationId}>{heading.locationName}</option>
                              ))}
                            </select>
                            <span className="hidden">This field is mandatory</span>
                          </div>
                        </div>
                        <div className="flex-none md:w-1/6">
                          <div className="w-full flex flex-col">
                            <label htmlFor="divsion" className="text-[12px]">Division <sup>*</sup></label>
                            <select id="divsion" name="divsion" ref={divRef} value={divonchg} className="block w-full" onChange={handleTeamChange} >
                              <option value='' selected>Select Division</option>
                              {divVal?.map((divVals) => (
                                <option value={divVals.divisionID} custom={divVals.functionName} data-set={divVals.functionName}>{divVals.divisionName}</option>
                              ))}
                            </select>
                            <span className="hidden">This field is mandatory</span>
                          </div>
                        </div>
                        <div className="flex-none md:w-1/6">
                          <div className="w-full flex flex-col">
                          <label htmlFor="team" className="text-[12px]">Team </label>
                            <select id="team" name="team" ref={teamRef} disabled={teamVal.length>0 ? false :true } className="block w-full">
                              <option value=''>Select Team</option>
                              {teamVal?.map((teamVals) => (
                                <option value={teamVals.teamID}>{teamVals.teamName}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="flex-none">
                          <div className="w-full flex flex-col">
                            <label htmlFor="stream" className="text-[12px]">Stream</label>
                            <select
                              id="stream"
                              name="stream"
                              ref={streamRef}
                              className="block w-full"
                            >
                              <option value=''>Select Stream</option>
                              {latFilDat?.streams?.map((heading, i) => (
                                <option value={heading.streamId}>{heading.streamName}</option>
                              ))}

                            </select>
                          </div>
                        </div>
                        <div className="flex-none">
                          <div className="w-full flex flex-col">
                            <label htmlFor="substream" className="text-[11px]">Substream </label>
                            <select
                              id="substream"
                              name="substream"
                              ref={substreamRef}
                              className="block w-full"
                            >
                              <option value=''>Select Substream</option>
                              {latFilDat?.subStreamDetails?.map((heading, i) => (
                                <option value={heading.subStreamId}>{heading.subStreamName}</option>
                              ))}

                            </select>
                          </div>
                        </div>
                        <div className="flex-none ml-auto">
                          <button className="flex clr-btn" onClick={resetFilter}>Reset</button>
                        </div>
                        <div className="flex-none ml-0">
                          <button className="flex" onClick={applyFilter}>Filter</button>
                        </div>

                      </div>
                    </div>
                  </div>
                  <div className="hidden" ref={loadingRef}><Loading /></div>
                  {Object.keys(resData1).length == 0 ?
                    <div className="career_lattice not_found" ref={carlatRef}><img src={norecrd} alt="No record" /></div> :
                    <div className="career_lattice" ref={carlatRef}>
                      <div className="relative">
                        <div className="flex main-holder">
                          <div className="flex flex-wrap flex-col first-col">
                            <div className="flex flex-nowrap">
                              <div className="flex-none">
                                <div className="stream-label">STREAM<p><i className="text-[8px]">[Substream]</i></p> </div>
                              </div>
                            </div>
                            {Object.keys(resData1)?.map((data, index) => {
                              currentLvel = data;
                              let colmath = index > 6 ? Math.floor(index / rand.length) : index;
                              //console.log('colmath>>>',colmath,'stream>>>>',currentLvel,'oldStream>>>',oldStream);
                              oldBgColor = currentLvel != oldStream ? { backgroundColor: rand[colmath] } : oldBgColor;
                              oldStream = currentLvel;
                              return (
                                <>
                                  {Object.keys(resData1[data])?.map((substream) => {
                                    return (
                                      <div className=" flex-nowrap">
                                        <div className="flex-none">
                                          <div className="stream-data-label leading-[1]" style={oldBgColor}>
                                            {currentLvel} <i className="text-[8px]">[ {substream} ]</i>
                                            {/* {substream} */}
                                          </div>
                                        </div>
                                      </div>
                                    )
                                  }
                                  )}
                                </>
                              )

                            })}
                          </div>
                          <div className="flex flex-nowrap flex-col overflow-auto main-col">
                            <div className="top-head flex flex-nowrap levels-label">
                              <div className="">
                                <div className="flex">LEVEL 1</div>
                              </div>
                              <div className="">
                                <div className="flex">LEVEL 2</div>
                              </div>
                              <div className="">
                                <div className="flex">LEVEL 3</div>
                              </div>
                              <div className="">
                                <div className="flex">LEVEL 4</div>
                              </div>
                              <div className="">
                                <div className="flex">LEVEL 5</div>
                              </div>
                              <div className="">
                                <div className="flex">LEVEL 6</div>
                              </div>
                              <div className="">
                                <div className="flex">LEVEL 7</div>
                              </div>
                              <div className="">
                                <div className="flex">LEVEL 8</div>
                              </div>
                              <div className="">
                                <div className="flex">LEVEL 9</div>
                              </div>
                            </div>

                            {Object.values(resData1).map((data, index) => {

                              return (

                                Object.values(data)?.map((level, idx) => {
                                  jobRows++;
                                  return (
                                    <div className="flex flex-nowrap joblist">
                                      {lvlArrVal.map((element) => {
                                        return (

                                          <div className="">
                                            <div
                                              className={
                                                !Object.keys(level).includes(element) ? "flex relative opacity-30 no-level" : level[element].length > 1 ? "flex relative moredata" : "flex relative"
                                              }
                                            >
                                              <Lattice data={Object.keys(level).includes(element) ? level[element] : ['']} index={idx} jobrws={jobRows} setSlideData={setSlideData} />
                                            </div>
                                          </div>
                                        )
                                      }
                                      )}
                                    </div>
                                  )
                                }
                                )


                              )
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </main>
              </div>
            </div>
            {slideData}
          </main>
        </div>
      </div>


    </>
  );

}
export default PresentationServices;

